// extracted by mini-css-extract-plugin
export var cardHeader = "_hb-0";
export var reorderHandle = "_hb-3";
export var titleArea = "_hb-1";
export var titleAreaWithHandle = "_hb-2";